var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM7.293 5.707C7.11084 5.5184 7.01005 5.2658 7.01233 5.0036C7.0146 4.7414 7.11977 4.49059 7.30518 4.30518C7.49059 4.11977 7.7414 4.0146 8.0036 4.01233C8.2658 4.01005 8.5184 4.11084 8.707 4.293L11.707 7.293C11.8945 7.48053 11.9998 7.73484 11.9998 8C11.9998 8.26516 11.8945 8.51947 11.707 8.707L8.707 11.707C8.5184 11.8892 8.2658 11.99 8.0036 11.9877C7.7414 11.9854 7.49059 11.8802 7.30518 11.6948C7.11977 11.5094 7.0146 11.2586 7.01233 10.9964C7.01005 10.7342 7.11084 10.4816 7.293 10.293L8.586 9H5C4.73478 9 4.48043 8.89464 4.29289 8.70711C4.10536 8.51957 4 8.26522 4 8C4 7.73478 4.10536 7.48043 4.29289 7.29289C4.48043 7.10536 4.73478 7 5 7H8.586L7.293 5.707Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.49f4761861f6f7a50f62e40e4c5273c8.svg";
export { ForwardRef as ReactComponent };